export function objectArrayDiff<T>(
  objectKey: string,
  array1?: T[],
  array2?: T[],
) {
  return array1?.filter(
    (a1) => !array2?.find((a2) => a1[objectKey] === a2[objectKey]),
  );
}
